import { inject, Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClientDto } from 'src/app/models/client/client-dto';
import { NodeConfigurationType } from 'src/app/models/process-element-search-dto';
import { ProcessElementDto } from 'src/app/models/process/process-element-dto';
import { ClientService } from 'src/app/services/api/client-api';
import { ProcessElementsService } from 'src/app/services/api/process-api';
import { CloneService } from 'src/app/services/local/clone.service';
import { NotificationRulesMetadataIds } from '../model/notification-rules-metadata-ids';
import { NotificationRulesMetadataValues } from '../model/notification-rules-metadata-values';

@Injectable()
export class NotificationRulesMetadataService {
  private clientService = inject(ClientService);
  private processElementsService = inject(ProcessElementsService);
  private cloneService = inject(CloneService);

  getFilterMetadata$(
    metadataIds: NotificationRulesMetadataIds
  ): Observable<NotificationRulesMetadataValues> {
    if (!metadataIds) {
      return;
    }

    const ids = this.cloneService.deepClone(metadataIds);

    const requests: Observable<any>[] = [];

    requests.push(
      ids.processNodeIds?.length > 0
        ? this.processElementsService.getProcessElementByIds$(
            ids.processNodeIds,
            NodeConfigurationType.All
          )
        : of(null)
    );

    requests.push(
      ids.clientIds?.length > 0
        ? this.clientService.getBaseClients$(ids.clientIds)
        : of(null)
    );

    const requests$ = forkJoin(requests).pipe(
      map(([configurationElement, clients]) => {
        const result = <NotificationRulesMetadataValues>{
          processNodes: (configurationElement as ProcessElementDto[]) ?? [],
          clients: (clients as ClientDto[]) ?? []
        };

        return result;
      })
    );

    return requests$;
  }
}
